import React from 'react';
import Screen from '../Screen';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import Link from '../../elements/Link';

export default class EventFormCompletionScreen extends React.Component {
    render() {
        let {i18n} = this.props,
            header = <div><TopBarEvent event={this.props.event}/></div>;

        console.log(this.props);

        return <Screen header={header}>
            <div className="content full-center text-center" style={{
                    width: '85%',
                    fontSize: '180%'
                }}>
                <p>
                    <b>
                        <u>{i18n['label.thankyou']}</u>
                    </b>
                </p>
                <br/>
                <br/>
                <p>{this.props.form.confirmation_text}</p>
                <br/>
                <br/>
                <Link type="button" className="btn" href=".." style={{
                        ...this.props.event._local.styles.button,
                        width: '70%',
                        margin: 'auto'
                    }}>{i18n['label.continue']}</Link>
            </div>
        </Screen>;
    }
}
